export const getMobileSearchFilters = filters =>
  (Array.isArray(filters) ? filters : []).filter(filterConfig => filterConfig?.key !== 'dates');
